/* Handle accessibility tab focus when modal is opened */
(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // Helpers
    function handleInitialModalContentMutation(mutationList) {
      for (const mutation of mutationList) {
        const isContentInjected = (
          mutation.type === 'childList'
          && mutation.addedNodes.length > 0
        );

        if (isContentInjected) {
          const modalContent = document.querySelector('div[data-modal-container] > div[data-modal]');
          const modalContentObserver = new MutationObserver(handleModalContentOpenMutation);
          modalContentObserver.observe(modalContent, { attributes: true });
        }
      }
    }

    function handleModalContentOpenMutation(mutationList) {
      for (const mutation of mutationList) {
        const isOpenClassAdded = (
          mutation.type === 'attributes'
          && mutation.attributeName === 'class'
          && Array.from(mutation.target.classList).includes('is-open')
        );

        if (isOpenClassAdded ) {
          const modalOverlay = document.querySelector('div[data-modal-container] > div[data-modal] .modal__overlay');
          modalOverlay.focus();
        }
      }
    }

    function setupMutationObserver() {
      const modal = document.querySelector('div[data-modal-container]');
      const modalObserver = new MutationObserver(handleInitialModalContentMutation);
      modalObserver.observe(modal, { childList: true });
    }

    // Main
    setupMutationObserver();
  });
})();